module.exports = __webpack_public_path__ + "img/1-md.59a259a5.jpg";